import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {YzFileShowComponent} from "./yz-file-show.component";

@Injectable({
  providedIn: 'root'
})

export class FileShowService {

  constructor(public dialog: MatDialog) {
  }


  /**
   * 查看综合文件列表
   * @param option
   */
  viewFileShow(option: { id: string }) {
    if (!option.id) {
      return;
    }
    this.dialog.open(YzFileShowComponent, {
      panelClass: 'yz-iframe-page',
      closeOnNavigation: true,
      data: {
        id: option.id
      }
    });
  }


}

